import { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, IntlContext } from "react-intl";

class ButtonSendActivationMail extends Component {
    static contextType = IntlContext;
    state = {
        showDialog: false,
        dialogTitle: "",
        dialogMessage: "",
    };

    closeDialog = () => {
        this.setState({ showDialog: false });
    };

    sendActivationMail = () => {
        const { useDialog } = this.props;

        axios
            .post(
                `/User/SendActivationMail?email=${encodeURIComponent(
                    this.props.user.email
                )}`
            )
            .then((res) => {
                if (useDialog) {
                    this.setState({
                        showDialog: true,
                        dialogTitle: <FormattedMessage id="ActivationMailSentCopyUrl" />,
                        dialogMessage: res.data,
                    });
                } else {
                    toast.success(
                        <FormattedMessage id="NewActivationMailSent" />
                    );
                }
            })
            .catch((err) => {
                toast.warn(
                    <FormattedMessage id="NewActivationMailFailed" />
                );
            });
    };

    render() {
        const { showDialog, dialogTitle, dialogMessage } = this.state;
        const intl = this.context;

        return (
            <>
                <Button
                    outline
                    disabled={this.props.user.activatedAccount}
                    title={intl.formatMessage({
                        id: this.props.user.activatedAccount
                            ? "UserAccountActivatedTooltip"
                            : "UserAccountNotActivatedTooltip",
                    })}
                    size="sm"
                    color="info"
                    className={this.props.leftAlign ? "float-start" : "float-end"}
                    onClick={this.sendActivationMail}
                >
                    <FontAwesomeIcon icon="envelope" className="me-1" />
                    <FontAwesomeIcon icon="retweet" />
                    {this.props.printButtonText ? (
                        <> <FormattedMessage id="SendNewActivationMail" /></>
                    ) : ""}
                </Button>
                <Modal isOpen={showDialog} toggle={this.closeDialog} modalClassName="actmail-width-modal" className="actmail-width-modal">
                    <ModalHeader toggle={this.closeDialog}>{dialogTitle}</ModalHeader>
                    <ModalBody
                        style={{
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                            wordBreak: "break-all",
                            maxHeight: "60vh",
                            overflowY: "auto",
                            fontFamily: "monospace"
                        }}
                    >
                        {dialogMessage}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => navigator.clipboard.writeText(dialogMessage)}>
                            <FontAwesomeIcon icon={faCopy} className="me-2" /> <FormattedMessage id="Copy" />
                        </Button>
                        <Button color="primary" onClick={this.closeDialog}>
                            OK
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default ButtonSendActivationMail;
